// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"b60e9b08","967":"355bf08f"}[chunkId] + ".chunk.js";
};